"use client";

import * as React from "react";

export default function MoneyTransferSimulation() {
  const [balance, setBalance] = React.useState(100);
  const [amount, setAmount] = React.useState("");
  const [message, setMessage] = React.useState("");

  const handleSend = () => {
    const parsed = parseFloat(amount);
    if (isNaN(parsed) || parsed <= 0) {
      setMessage("Enter a valid amount.");
      return;
    }

    const hiddenFee = parsed * 0.1; // 💸 10% hidden fee
    const total = parsed + hiddenFee;

    if (total > balance) {
      setMessage("Insufficient balance.");
      return;
    }

    setBalance((prev) => prev - total);

    setMessage(
      `You sent £${parsed.toFixed(2)}, but a hidden £${hiddenFee.toFixed(
        2
      )} fee was deducted.\n\n💡 You just got caught in a harmful design pattern.`
    );
    setAmount("");
  };

  return (
    <div
      style={{
        width: 300,
        margin: "40px auto",
        background: "#f5f7fa",
        borderRadius: 16,
        padding: 20,
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        fontFamily: "system-ui, sans-serif",
        textAlign: "center",
      }}
    >
      <h3 style={{ marginBottom: 10 }}>Send Money</h3>
      <div style={{ marginBottom: 10 }}>
        Balance: <strong>£{balance.toFixed(2)}</strong>
      </div>

      <input
        type="number"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        placeholder="Enter amount"
        style={{
          width: "100%",
          padding: 8,
          borderRadius: 8,
          border: "1px solid #ccc",
          marginTop: 6,
        }}
      />

      <button
        onClick={handleSend}
        style={{
          marginTop: 10,
          width: "100%",
          background: "#007aff",
          color: "white",
          border: "none",
          padding: 10,
          borderRadius: 8,
          cursor: "pointer",
          fontWeight: 600,
        }}
      >
        Send
      </button>

      <div
        style={{
          marginTop: 16,
          minHeight: 40,
          fontSize: 14,
          whiteSpace: "pre-line",
        }}
      >
        {message}
      </div>
    </div>
  );
}
